export default {
	id: 'SIMPLE_PREMIUM_FALLBACK_4W_29_99_1W_3_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_4w_29_99_1w_3_99_usd',
			EUR: 'simple_premium_4w_29_99_1w_3_99_eur',
			GBP: 'simple_premium_4w_29_99_1w_3_99_gbp',
			AUD: 'simple_premium_4w_49_99_1w_6_39_aud',
			CAD: 'simple_premium_4w_49_99_1w_6_39_cad',
			DKK: 'simple_premium_4w_259_1w_31_2_dkk',
			SEK: 'simple_premium_4w_399_1w_47_2_sek',
			NOK: 'simple_premium_4w_399_1w_47_2_nok',
			BRL: 'simple_premium_4w_99_1w_13_6_brl',
			MXN: 'simple_premium_4w_499_1w_63_2_mxn',
			TRY: 'simple_premium_4w_999_1w_135_2_try',
			ARS: 'simple_premium_4w_39990_1w_5272_ars',
			COP: 'simple_premium_4w_119990_1w_15992_cop',
			CLP: 'simple_premium_4w_29990_1w_3832_clp',
		},
		primer: 'prd_ebwsMmPIKFsr',
	},
}
